// 订单表格头部
export const orderColumns = [{
  title: '订单编号',
  dataIndex: 'order_num'
}, {
  title: '订单状态',
  dataIndex: 'order_status'
}, {
  title: '下单日期',
  dataIndex: 'create_time'
}, {
  title: '组件数量(件)',
  dataIndex: 'goods_count'
}, {
  title: '操作',
  dataIndex: 'operate',
  name: '操作详情'
}];

// 个人信息头部
export const personalColumns = [{
  title: '姓名',
  dataIndex: 'username'
}, {
  title: '手机号',
  dataIndex: 'mobile'
}, {
  title: '所在部门',
  dataIndex: 'department_name'
}, {
  title: '绑定邮箱',
  dataIndex: 'email'
}, {
  title: '公司名称',
  dataIndex: 'company_name'
}, {
  title: '操作',
  dataIndex: 'operation',
  key: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];
// 个人信息头部
export const productColumns = [{
  title: '产品名称',
  dataIndex: 'presentation_name'
},
// {
//   title: '产品ID',
//   dataIndex: 'presentation_id'
// },
{
  title: '试用开始时间',
  dataIndex: 'start_time'
}, {
  title: '试用结束时间',
  dataIndex: 'end_time'
}];

// 组件信息--列
export const componentColumns = [{
  title: '产品名称',
  dataIndex: 'goods_name',
  key: 'goods_name'
}, {
  title: '类别',
  dataIndex: 'goods_type',
  key: 'goods_type',
  scopedSlots: {
    customRender: 'goods_type'
  }
}, {
  title: '操作',
  dataIndex: 'operation',
  key: 'operation',
  scopedSlots: {
    customRender: 'operation'
  }
}];

// 组件分类tab
export const packageCategory = [{
  key: 0,
  value: '全部',
  label: '全部'
}, {
  key: 1,
  value: '组件',
  label: '组件'
}, {
  key: 2,
  value: '接口',
  label: '接口'
}];